export { default } from './CatalogCarCard';
